export const unique = <T>(items: T[]): T[] => {
  return items.reduce<T[]>((acc, item) => {
    if (acc.indexOf(item) < 0) {
      acc.push(item);
    }

    return acc;
  }, []);
};
